import { render } from "./AuthDlg.vue?vue&type=template&id=4d654ebb"
import script from "./AuthDlg.vue?vue&type=script&lang=js"
export * from "./AuthDlg.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexeysorokin/Desktop/hexp2/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__